import React, { useState, useEffect, useRef } from "react";
import { Link, NavLink, BrowserRouter, useHistory } from "react-router-dom";
import config from "../../config";
import {
  getLogout,
  username,
  email,
  roleid,
  token,
  role,
  profile_pic,
} from "../Actions/AuthAction";
import { Unreadnotificationcount } from "../Actions/CommonAction";

const TopBar = (props) => {
  const history = useHistory();
  const sample = "assets/img/logo user.png";
  const logout = (e) => {
    //alert("fsdf");
    // if (getLogout(props)) {
    //   history.push("/");
    // }
    getLogout(props);
  };

  const [unreadnoti, setUnreadnoti] = useState(0);

  useEffect(() => {
    const model = {
      loginusertoken: token(),
    };
    Unreadnotificationcount(model).then((res) => {
      setUnreadnoti(res.unread);
    });
  });

  return (
    <>
      <nav class="navbar navbar-expand">
        <button
          class="btn btn-link btn-sm order-1 order-lg-0 togglebtn"
          id="sidebarToggle"
          href="#"
        >
          <i class="fas fa-arrow-left"></i>
        </button>

        {/* <form class="d-none d-md-inline-block form-inline ml-auto mr-0 mr-md-3 my-2 my-md-0">
          <div class="input-group searchform">
            <input
              class="form-control"
              type="text"
              placeholder="Search for..."
              aria-label="Search"
              aria-describedby="basic-addon2"
            />
            <div class="input-group-append">
              <button class="btn btn-primary" type="button">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
        </form> */}

        <ul class="navbar-nav ml-auto mr-0 mr-md-3 my-2 my-md-0">
          <li>
            <Link to="/notification" class="notif position-relative">
              <i class="fa fa-bell"></i>
              <span className="counter">{unreadnoti}</span>
            </Link>
          </li>
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              id="userDropdown"
              href="#"
              role="button"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {profile_pic() != "" ? (
                <>
                  {roleid() != 1 ? (
                    <img
                      src={`${config.IMAGE_URL}/${profile_pic()}`}
                      class="user-img ml-2"
                    />
                  ) : (
                    <img
                      src={`${config.DOMAIN_URL}/${profile_pic()}`}
                      class="user-img ml-2"
                    />
                  )}
                </>
              ) : (
                <img src={`${config.DOMAIN_URL}/${sample}`} class="user-img" />
              )}
            </a>
            <div
              class="dropdown-menu dropdown-menu-right"
              aria-labelledby="userDropdown"
            >
              <div class="d-flex justify-content-start border-bottom">
                {profile_pic() != "" ? (
                  <>
                    {roleid() != 1 ? (
                      <img
                        src={`${config.IMAGE_URL}/${profile_pic()}`}
                        class="user-img ml-2"
                      />
                    ) : (
                      <img
                        src={`${config.DOMAIN_URL}/${profile_pic()}`}
                        class="user-img ml-2"
                      />
                    )}
                  </>
                ) : (
                  <img
                    src={`${config.DOMAIN_URL}/${sample}`}
                    class="user-img ml-2"
                  />
                )}
                <div class="ml-4 username">
                  <h4 class="mb-0">{username()}</h4>
                  <p>{email()}</p>
                  <p className="role">{role()}</p>
                </div>
              </div>

              {roleid() && roleid() == 2 ? (
                <Link class="dropdown-item" to="/institutionprofile">
                  <i class="fa fa-user" aria-hidden="true"></i> Profile
                </Link>
              ) : roleid() && roleid() == 3 ? (
                <Link class="dropdown-item" to="/recruiterprofile">
                  <i class="fa fa-user" aria-hidden="true"></i> Profile
                </Link>
              ) : roleid() && roleid() == 4 ? (
                <Link class="dropdown-item" to="/employerprofile">
                  <i class="fa fa-user" aria-hidden="true"></i> Profile
                </Link>
              ) : roleid() && roleid() == 5 ? (
                <Link class="dropdown-item" to="/profile">
                  <i class="fa fa-user" aria-hidden="true"></i> Profile
                </Link>
              ) : roleid() && roleid() == 6 ? (
                <Link class="dropdown-item" to="/universityprofile">
                  <i class="fa fa-user" aria-hidden="true"></i> Profile
                </Link>
              ) : roleid() && roleid() == 7 ? (
                <Link class="dropdown-item" to="/companyprofile">
                  <i class="fa fa-user" aria-hidden="true"></i> Profile
                </Link>
              ) : roleid() && roleid() == 8 ? (
                <Link class="dropdown-item" to="/leadprofile">
                  <i class="fa fa-user" aria-hidden="true"></i> Profile
                </Link>
              ) : (
                <span></span>
              )}

              <Link class="dropdown-item" to="/changepassword">
                <i class="fa fa-key" aria-hidden="true"></i> Change Password
              </Link>
              <div class="text-center">
                <a
                  class="btn btn-primary"
                  href="javascript:void(0)"
                  onClick={logout}
                >
                  Logout
                </a>
              </div>
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};
export default TopBar;
